module.exports = __webpack_public_path__ + "img/immigration.add5fa6f.png";